import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DialogCloseReason } from '../base-dialog';
import { ConfirmDialogComponent } from '../confirm/confirm.component';
import { FileModel } from '../../typescript-angular-client/model/models';

@Component({
  selector: 'lib-file-delete-alert',
  templateUrl: './file-delete-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileDeleteAlertComponent extends ConfirmDialogComponent {

  itemsCount: number = 1;
  isJustFolder: boolean = false;
  isFileDialogType: boolean = false;
  headerText: string = '';

  constructor() { super(); }

  initDialog() {
    super.initDialog();
    this.itemsCount = this.extraData.itemsCount ? this.extraData.itemsCount : 1;
    this.isJustFolder = this.extraData.isJustFolder ? this.extraData.isJustFolder : false;
    this.isFileDialogType = this.extraData.dialogType !== FileModel.FileTypeEnum.IMAGES;

    if (this.isJustFolder) {
      this.headerText =  'COMMON.DIALOGS.DELETE_FOLDER.DELETE_FOLDER';
    } else {
      if (this.itemsCount > 1) {
        this.headerText = 'COMMON.DIALOGS.DELETE_FILE.DELETE_ITEMS';
      } else {
        this.headerText = this.isFileDialogType ? 'COMMON.DIALOGS.DELETE_FILE.DELETE_FILE' : 'COMMON.DIALOGS.DELETE_FILE.DELETE_IMAGE';
      }
    }
  }

  ok() {
    this.close({ reason: DialogCloseReason.OK, data: {} });
  }
}
